import {TableColumnsType} from 'antd';
import {SortOrder} from 'antd/es/table/interface';

import {Locale} from '../../../../../../provider/locale/localization';
import {SavedSortStateType} from '../../../../../../util/save-sort-table-state/save-sort-table-type';

import {CompetitorsTableRowDataType} from './competitors-table-type';

export function useCompetitorsColumnList(): TableColumnsType<CompetitorsTableRowDataType> {
    return [
        {
            title: <Locale stringKey="TABLE__HEADER__TITLE" />,
            dataIndex: 'name',
        },
        {
            title: <Locale stringKey="TABLE__HEADER__ADDRESS" />,
            dataIndex: 'address',
        },
        {
            title: <Locale stringKey="TABLE__HEADER__CODE" />,
            dataIndex: 'code',
        },
        {
            title: <Locale stringKey="REVIEWS_ANALYSIS__COMPETITORS__TABLE_HEADER__CITY" />,
            dataIndex: 'city',
        },
        {
            title: <Locale stringKey="REVIEWS_ANALYSIS__COMPETITORS__TABLE_HEADER__TRAFFIC_GROWTH" />,
            dataIndex: 'growthPotentialPercent',
            sorter: true,
            align: 'right',
        },
        {
            title: <Locale stringKey="REVIEWS_ANALYSIS__COMPETITORS__TABLE_HEADER__VIEWS_POTENTIAL" />,
            dataIndex: 'weeklyExtraViews',
            sorter: true,
            align: 'right',
        },
        {
            title: <Locale stringKey="REVIEWS_ANALYSIS__COMPETITORS__TABLE_HEADER__TARGET_RATING" />,
            dataIndex: 'targetRating',
            sorter: true,
            align: 'right',
        },
    ];
}

export function addInitialSort(
    columns: TableColumnsType<CompetitorsTableRowDataType>,
    defaultSortColumn: SavedSortStateType | null
): TableColumnsType<CompetitorsTableRowDataType> {
    if (!defaultSortColumn) {
        return columns;
    }

    const order = defaultSortColumn.order;

    const defaultSortOrder: SortOrder | undefined = order === 'ascend' || order === 'descend' ? order : null;
    const dataIndex = defaultSortColumn.field;

    return columns.map((column) => {
        if ('dataIndex' in column && column.dataIndex === dataIndex) {
            return {
                ...column,
                sorter: true,
                defaultSortOrder,
            };
        }

        return column;
    });
}
